import { getToken } from '@/libs/util.token'
export default ({ request }) => ({
  ecomHxFtyPurchaseListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/save',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDelApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/del',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseBindingApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/binding',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseSubmitApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/submit',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseReviewApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/review',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseRejectApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/reject',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDetailOptionsApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/detail/options',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDetailListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDetailAddApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/detail/add',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDetailUpdateApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/detail/update',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseDetailDelApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseBatchListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/batch/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseBatchSelectTotalApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/batch/selectTotal',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseBatchSkuListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/batch/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyPurchaseFileParseApi(file) {
    const data = new FormData()
    data.append('file', file)

    return request({
      url: '/ecom/hx/fty/purchase/fileParse',
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
    })
  },
  ecomHxFtyPurchaseImportSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/purchase/importSave',
      method: 'POST',
      data,
    })
  },
})
